export const HOST_SOCIAL_ICONS_MAP = {
  facebook: 'facebook',
  fb: 'facebook',
  x: 'twitter',
  twitter: 'twitter',
  google: 'google',
  instagram: 'instagram',
  linkedin: 'linkedin',
  pinterest: 'pinterest',
  youtube: 'youtube',
  'youtu.be': 'youtube',
};
